import {Component} from "react"
import api from "../../../../../api.js"
import {toastr} from "react-redux-toastr"
import {reset} from "redux-form"
import {Link} from "react-router-dom"
import {isArray} from "validate.js"
import {connect} from "react-redux"

import {generate} from "../../../../routes.js"
import conf from "../../../../../shared/conf.js"
import {prepareFreelanceBeforeSubmit} from "../../../../../shared/services/freelanceService.js"
import {prepareUserBeforeSubmit} from "../../../../../shared/services/userService.js"
import EditPasswordForm, {name} from "../../../../components/Forms/EditPasswordForm/EditPasswordForm.jsx"
import UploadUserImageForm from "../../../../components/Forms/UploadUserImageForm/UploadUserImageForm.jsx"
import DoForm from "../../../../components/Forms/DoForm/DoForm.jsx"
import SubmitDoButton from "../../../../components/Forms/DoForm/SubmitButton.jsx"
import SubmitPasswordButton from "../../../../components/Forms/EditPasswordForm/SubmitButton.jsx"
import connectModal from "../../../../../shared/components/Modals/connect.js"
import RemoveModal from "../../../../../shared/components/Modals/RemoveModal/RemoveModal.jsx"
import ConfirmModal from "../../../../../shared/components/Modals/ConfirmModal/ConfirmModal.jsx"
import Card from "../../../../../shared/components/Styled/Card/Card.jsx"
import CardRow from "../../../../../shared/components/Styled/Card/CardRow.jsx"
import CardCol from "../../../../../shared/components/Styled/Card/CardCol.jsx"
import RoundedPage from "../../../../../shared/components/Styled/Containers/RoundedPage.jsx"

class MyAccountContent extends Component {

  submitPassword = async (values) => {
    await api.users.changePassword(values)
      .then((succesResponse) => {
        toastr.success('Les modifications ont correctement été enregistrées')
        this.props.dispatch(reset(name))
      })
      .catch((errors) => {
        let errorMessage = 'Une erreur est survenue'
        if(errors.data && errors.data.errors && isArray(errors.data.errors)) {
          const hasOldMessageError = errors.data.errors.find((error) => {return error.field === 'old_password'})
          if(hasOldMessageError) {
            document.querySelector('#EditPasswordForm_ioldPassword').className = 'form-control is-invalid'
          }
          errorMessage = errors.data.errors.map((msg) => msg.message).join('\r\n')

        }
        toastr.error(errorMessage)
      })
  }

  deleteAccount = (event) => {
    event.preventDefault()
    this.openRemoveModal()
  }
  hardDeleteAccount = (event) => {
    event.preventDefault()
    this.confirmModal(() => {
      this.removeUser(false)
    })
  }

  openRemoveModal = () => {
    const {freelance} = this.props

    this.props.openRemoveModal({
      user: this.props.currentUser,
      onHardDelete: () => {
        window.location = generate({
          name: 'homepage',
          search: {action: 'confirmDeletion'}
        })
      },
      onSoftDelete: () => {
        toastr.success('Votre compte a bien été supprimé.')
        setTimeout(() => {
          window.location = `${process.env.API_URL}/logout`
        }, 1000 * 1) // 1 sec
      },
      onLongTermContractUpdated: (hasLongTermContract) => this.props.submit({
        freelance: {
          ...prepareFreelanceBeforeSubmit(freelance),
          cdi: true,
        },
        user: prepareUserBeforeSubmit(this.props.currentUser)
      }),
    })
  }

  confirmModal = (confirmAction) => {
    this.props.openConfirmModal({
      header: 'Supprimer mon compte',
      body: 'Vous confirmer vouloir supprimer votre compte ?',
      confirmText: 'Confirmer',
      cancelText: 'Annuler',
      confirmAction: confirmAction,
    })
  }

  removeUser = async (softDelete) => {
    try {
      await api.users.remove({
        user: this.props.currentUser.id,
      }, {
        qs: {
          softdelete: softDelete,
        }
      })
    } catch(e) {
      console.warn(e)
    } finally {
      window.location = generate({
        name: 'homepage',
        search: {action: 'confirmDeletion'}
      })
    }
  }

  onSubmit = (values) => {
    return this.props.submitUser({
      ...values,
    })
  }
  onUploadSuccess = (image) => {
    this.props.updateUser({
      ...this.props.currentUser,
      image,
    })
  }

  render() {
    const {currentUser} = this.props
    const isAgent = (currentUser) &&  currentUser.isBusinessManager
    const isFreelanceAccount = (currentUser) && currentUser.account_type === conf.accountTypes.freelance
    const isDoAccount = (currentUser) && currentUser.account_type === conf.accountTypes.do

    return (
      <RoundedPage>
        <h2 className="text-center">Mon compte</h2>

        <h4 className="text-center mt-5">Présentation générale</h4>

        <CardRow>
          <CardCol align={'center'} flex={1}><p className="text-center mb-5">
            Merci de nous aider à vous connaitre
          </p></CardCol>
        </CardRow>

        {isAgent && (
          <div className="row justify-content-center">
            <div className="col-xl-9">
              <UploadUserImageForm
                image={currentUser.image}
                userId={currentUser.id}
                onUploadSuccess={this.onUploadSuccess}
                className="my-account-profile-image"
              >
              </UploadUserImageForm>
            </div>
          </div>
        )}

        {(isDoAccount || isAgent) && (
          <Card className={'bg-gray-200'}
            p="25px"
            title={<h4 className="text-center">Informations personnelles</h4>}>
            <CardRow>
              <CardCol align={'center'} flex={1}><p className="text-center mb-5">
                Merci de nous aider à vous connaitre
              </p></CardCol>
            </CardRow>
            <CardRow>
              <CardCol flex={1}>
                <DoForm
                  onSubmit={this.onSubmit}
                  initialValues={this.props.currentUser}
                  onSubmitSuccess={this.props.onFormSuccess}/>
              </CardCol>
            </CardRow>
            <CardRow justify="center" className={'mt-3'}>
              <CardCol>
                <SubmitDoButton className="btn btn-primary mx-auto">Sauvegarder</SubmitDoButton>
              </CardCol>
            </CardRow>
          </Card>
        )}

        {isFreelanceAccount &&
          <Card className={'bg-gray-200'}
            p="25px"
            title={<h4 className="text-center">Informations personnelles</h4>}>
            <CardRow>
              <CardCol>
                <Link to={generate({name: 'edit-freelance.pres'})} className="">Cliquez-ici</Link>{' '}
                si vous souhaitez modifier des informations relatives à votre profil, votre compte, votre
                recherche, votre TJM, etc.
              </CardCol>
            </CardRow>
          </Card>
        }

        <Card className={'bg-gray-200'}
          p="25px"
          title={<h6 className="text-center">Mot de passe</h6>}>
          <EditPasswordForm
            enableReinitialize={true}
            initialValues={{
              oldPassword: null,
              newPassword: {
                confirmation: null,
                password: null,
              }
            }}
            onSubmit={this.submitPassword}
            onSubmitSuccess={() => {
            }}
          />
          <CardRow className='edit-password-form-row' gap={'10px'}>
            <CardCol flex="1 0 50%"/>
            <CardCol flex="1 0 50%">
              <SubmitPasswordButton className="btn btn-primary mt-1">Sauvegarder </SubmitPasswordButton>
            </CardCol>
          </CardRow>
        </Card>

        {isDoAccount && !isAgent && (
          <Card className={'bg-gray-200'}
            p="25px"
            title={<h6 className="text-center">Supprimer mon compte</h6>}>
            <CardRow justify={'center'}>
              <CardCol>
                <a href={' '} onClick={this.hardDeleteAccount}>Cliquez-ici</a> si vous souhaitez supprimer votre
                compte.
              </CardCol>
            </CardRow>
          </Card>
        )}

        {isAgent && (
          <Card className={'bg-gray-200'}
            p="25px"
            title={<h6 className="text-center">Supprimer mon compte</h6>}>
            <CardRow justify={'center'}>
              <CardCol>
                <a href={' '} onClick={this.deleteAccount}>Cliquez-ici</a> si vous souhaitez supprimer votre
                compte.
              </CardCol>
            </CardRow>
          </Card>
        )}

        {isFreelanceAccount && (
          <Card className={'bg-gray-200'}
            p="25px"
            title={<h6 className="text-center">Supprimer mon compte</h6>}>
            <CardRow justify={'center'}>
              <CardCol>
                <a href={' '} onClick={this.deleteAccount}>Cliquez-ici</a> si vous souhaitez supprimer votre
                compte.
              </CardCol>
            </CardRow>
          </Card>
        )}
      </RoundedPage>
    )
  }
}

export default connect((state) => {
  return {currentUser: state?.currentUser.user ?? {}}
})(connectModal({
  RemoveModal, ConfirmModal}, MyAccountContent))
